import React from 'react';

const Home = () => (
  <div className="container my-5">
    <h1>Welcome to Dream India School</h1>
    <p>This is the homepage for the School Management System built in React.</p>
  </div>
);

export default Home;
